import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 0 auto;

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 700px;
  }
`;
